import { Fragment } from "react";
import { FieldValues, useFormState } from "react-hook-form";

type FormTouchedCallbackProps = {
    callback: () => void;
};

const FormTouchedCallback = <T extends FieldValues>({
    callback
}: FormTouchedCallbackProps) => {
    const { touchedFields } = useFormState<T>();

    if (touchedFields && Object.keys(touchedFields).length > 0) {
        callback?.();
    }
    return <Fragment />;
};

export { FormTouchedCallback };
